import { render, staticRenderFns } from "./Hour24Regist.vue?vue&type=template&id=5b100e34&scoped=true&"
import script from "./Hour24Regist.vue?vue&type=script&lang=ts&"
export * from "./Hour24Regist.vue?vue&type=script&lang=ts&"
import style0 from "./Hour24Regist.vue?vue&type=style&index=0&id=5b100e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b100e34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow,VSpacer})
